import React, { lazy, Suspense, Fragment } from 'react';
import Download from '@bitcoin-portal/bitcoincom-pkg-components/dist/Download';
import { FooterSection, FooterParagraph, SelectContainer, LogoWrapper, Apps, } from '../../styled';
const Logo = lazy(() => import('@bitcoin-portal/bitcoincom-pkg-components/dist/Logo'));
const LanguageSelect = lazy(() => import('../LanguageSelect'));
const Header = (props) => {
    const { legalStrings, setSelectedLocale, locale, localesList, contrast } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(FooterSection, { area: "header" },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(LogoWrapper, null,
                    React.createElement(Logo, { contrast: contrast }))),
            localesList && (React.createElement(SelectContainer, null,
                React.createElement(Suspense, { fallback: React.createElement("div", null) },
                    React.createElement(LanguageSelect, { locale: locale, setSelectedLocale: (lang) => setSelectedLocale(lang), localesList: localesList })))),
            React.createElement(FooterParagraph, null, legalStrings.copyright.map((s) => (React.createElement(Fragment, { key: s },
                s.replace('{year}', new Date().getFullYear().toString()),
                React.createElement("br", null))))),
            React.createElement(Apps, null,
                React.createElement(Download, { link: "https://apps.apple.com/us/app/bitcoin-wallet-by-bitcoin-com/id1252903728?ls=1", type: "ios", className: "ga-wallet-cta" }),
                React.createElement(Download, { link: "https://play.google.com/store/apps/details?id=com.bitcoin.mwallet", type: "google", className: "ga-wallet-cta" })))));
};
export default Header;
//# sourceMappingURL=Header.js.map